export interface Filters {
	[key: string]: string | boolean
}

export type FilteringTypes = 'feedbackType' | 'status';

export enum FeedbackTypes {
	BugReport = 'BugReport',
	FlagOfAbuse = 'FlagOfAbuse',
	GeneralFeedback = 'GeneralFeedback',
	Help = 'Help',
	VideoFeedback = 'VideoFeedback'
}

export enum Status{
	Pending = "InProgress",
	Resolved = "Completed",
	Unassigned = "Unassigned",
}